<!--
  点餐
  lovi 2020-06-19
-->
<template>
  <div>
    <div class="shop-wrap">
      <van-sticky class="sidebar-sticky" :offset-top="taboffsetH">
        <van-sidebar v-model="activeSidebar">
          <van-sidebar-item
            v-for="(item, index) in list"
            :key="index"
            :title="item.category_name"
            :badge="item.count ? item.count : ''"
            @click="clickTab"
          />
        </van-sidebar>
      </van-sticky>
      <div class="shop-list">
        <div
          class="classify"
          v-for="(classify, classifyIndex) in list"
          :key="classifyIndex"
          ref="offerTop"
          :style="`z-index:${classifyIndex}`"
        >
          <van-sticky class="title-sticky" :offset-top="taboffsetH">
            <h2 class="class-title">{{ classify.category_name }}</h2>
          </van-sticky>
          <shop-list
            v-for="(item, index) in classify.product"
            :key="index"
            :data="item"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ShopList from "@/components/life/shopList";
import { scrollAnimate } from "@/commonJs/index";
export default {
  props: ["taboffsetH", "list", "tabOffsetT"],
  components: {
    ShopList
  },
  data() {
    return {
      activeSidebar: 0,
      active: 0,
      offer: [],
      offerTop: []
    };
  },
  created() {
    // document.documentElement.scrollTop = 100;
  },
  mounted() {
    document.addEventListener("scroll", this.scroll);
  },
  computed: {},
  methods: {
    clickTab(val) {
      let el = document.documentElement || document.body || window;
      // console.log(
      //   "offerTop:",
      //   this.offerTop,
      //   "val:",
      //   val,
      //   "offerTop[val]",
      //   this.offerTop[val],
      //   "tabOffsetT",
      //   this.tabOffsetT,
      //   "taboffsetH",
      //   this.taboffsetH
      // );
      scrollAnimate(
        el,
        "y",
        this.offerTop[val] + this.tabOffsetT
        //  + this.taboffsetH
      );
      this.scrollFlag = true;
      setTimeout(() => {
        this.scrollFlag = false;
      }, 250);
      // this.$nextTick(() => {
      //   this.scrollFlag = false;
      // });
    },
    scroll() {
      if (this.scrollFlag) {
        return false;
      }
      let scrollTop =
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        window.pageYOffset;
      let top = scrollTop - this.tabOffsetT;
      //  - this.taboffsetH;
      for (let i = 0; i < this.offer.length; i++) {
        if (this.offer[i] >= top) {
          this.activeSidebar = i;
          break;
        }
      }
    }
  },
  watch: {
    list() {
      this.$nextTick(() => {
        let offerTop = this.$refs.offerTop;
        if (!offerTop) {
          return false;
        }
        for (let i = 0; i < offerTop.length; i++) {
          this.offer.push(offerTop[i].offsetTop + offerTop[i].offsetHeight);
          this.offerTop.push(offerTop[i].offsetTop);
        }
        // console.log("offer:", this.offer, "offerTop:", this.offerTop);
      });
    }
  },
  beforeDestroy() {
    document.removeEventListener("scroll", this.scroll);
  }
};
</script>

<style lang="less" scoped>
.shop-wrap {
  position: relative;
  display: flex;
  padding-left: 85px;
  /deep/.van-sidebar {
    position: absolute;
    left: 0;
  }
  .shop-list {
    flex: 1;
  }
}
.title-sticky {
  /deep/.van-sticky--fixed {
    left: 85px;
  }
}
/deep/.van-sticky--fixed {
  z-index: 80;
  .van-sidebar {
    height: calc(100vh - 44px - 50px);
    overflow-x: auto;
  }
}
.classify {
  position: relative;
}
.class-title {
  padding: 0 10px;
  line-height: 30px;
  font-size: 12px;
  font-weight: 500;
  background: #fff;
}
</style>
